import { BenefitsRoutes } from '@leagueplatform/benefits';
import { WalletRoutes } from '@leagueplatform/wallet';
import { FEATURE_FLAGS } from '@highmark-web/highmark-common';
import { useGetAppFeatureFlag } from '../../hooks/use-get-app-feature-flag.hook';

export const AppBenefitsRoutes = () => {
  const { isEnabled: isBenefitsLandingMasonryV2Enabled } = useGetAppFeatureFlag(
    FEATURE_FLAGS.ENABLE_BENEFITS_PAGE_2_0,
  );

  return isBenefitsLandingMasonryV2Enabled ? (
    <BenefitsRoutes />
  ) : (
    <WalletRoutes />
  );
};
